export class BluechatCompany {
  public id: string;
  public code: string;
  public name: string;
  public domains: string[];

  static fromDto(object: any): BluechatCompany {
    if (!object) {
      return null;
    }

    const company   = new BluechatCompany();
    company.id      = object.id;
    company.code    = object.code;
    company.name    = object.name;
    company.domains = object.domains;

    return company;
  }
}
